module.exports = __webpack_public_path__ + "img/Opinion1.650b8fbd.webp";